import { render, staticRenderFns } from "./billing-payment-details.vue?vue&type=template&id=2a5d9c94&"
import script from "./billing-payment-details.vue?vue&type=script&lang=js&"
export * from "./billing-payment-details.vue?vue&type=script&lang=js&"
import style0 from "./billing-payment-details.vue?vue&type=style&index=0&id=2a5d9c94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports